if(process.env.NODE_ENV === "production") {
    module.exports = require('./store.prod.js');
} else if(process.env.NODE_ENV === "test") {
    module.exports = require('./store.test.js');
} else {
    module.exports = require('./store.dev.js');
}